import { AnyIfEmpty } from "react-redux";
import { GET_CONCIERGE_FAILURE, GET_CONCIERGE_REQUEST, GET_CONCIERGE_SUCCESS } from "../constants/concierge.constants";
import { Dispatch, SetStateAction } from "react";
import axios from "axios";

const getConciergeRequest = () => {
    return {
        type: GET_CONCIERGE_REQUEST,
    };
};

const getConciergeSuccess = (conciergeData: AnyIfEmpty<object>) => {
    return {
        type: GET_CONCIERGE_SUCCESS,
        payload: conciergeData,
    };
};

const getConciergeFailure = (conciergeError: string) => {
    return {
        type: GET_CONCIERGE_FAILURE,
        payload: conciergeError,
    };
};

export const getConcierge = ({ leadName, startDate, endDate, propertyName, groups, page, limit, setTotalCount }: { leadName: string, startDate?: string, endDate?: string, propertyName?: string, groups?: string, page: number, limit: number, setTotalCount: Dispatch<SetStateAction<number>> }) => {
    return (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(getConciergeRequest());
        const params: Record<string, string | number> = { page, limit };
        if (leadName?.trim()) params.leadName = leadName.trim();
        if (startDate) params.startDate = startDate;
        if (endDate) params.endDate = endDate;
        if (propertyName?.trim()) params.propertyName = propertyName.trim();
        if (groups?.trim()) params.groups = groups.trim();
        return axios.get(`/concierge`, { params })
            .then((response) => {
                if (response?.data?.statusCode === 200) {
                    setTotalCount(response?.data?.count)
                    dispatch(getConciergeSuccess(response.data?.data ?? response.data?.ConciergeData ?? []))
                } else {
                    setTotalCount(0)
                    dispatch(getConciergeFailure(response.data.message))
                }
            }).catch((error) => {
                setTotalCount(0);
                dispatch(getConciergeFailure(error?.response?.data?.message || 'Something went wrong'));
            });
    }
}